export const deClientPortalAssetValuationList = {
    emptyStateTitle: 'Für diese Immobilie liegen noch keine Aufträge oder Bewertungen vor.',
    item: {
        valuationTitle: 'Wertgutachten {{date}}',
        valueCheckTitle: 'Wertüberprüfung {{date}}',
        downloadValueCheck: 'Wertüberprüfung herunterladen',
        generateValXml: 'ValXML generieren',
        downloadValuation: 'Gutachten herunterladen',
        noPdfTooltip: 'Für dieses Gutachten liegt keine PDF vor.',
    },
}
